import React from 'react';
import propTypes from 'prop-types';
import NavLink from './NavLink';
import {logoutUser} from '../../../actions/authentication/authentication'
import { connect } from 'react-redux';
import {pageTransition} from '../functions/pageTransition'

const ButtonAnchor = props => {
    let {path, anchorClass, disabled, internal, target, dispatch} = props;
    if( typeof path === "string" ){
        path = path.trim();
    };
    let buttonAnchor;

    // Page Transition is imported and handled in it's own function
    const handleClick = async (e) => {
        if (disabled) {
            e.preventDefault();
        } else {
            pageTransition(path,e);
        }
    };

    const handleLogOut = () => {
        dispatch(logoutUser())
        document.body.classList.remove( 'mobile-nav-active' )
    }

    // this if statement determines what type of button anchor we use, first we check if the path is logout and make it the logout button beacuse there is only one case of this, the next if statement is for any internal links where internal is passed as props and if not we use an external anchor tag

    if(path === '/logout') {
        buttonAnchor = (
            <button onClick={ handleLogOut} className={anchorClass}>
                {props.children}
            </button>
        )
    }
     else if (internal) {
        buttonAnchor = (
            <NavLink
                className={anchorClass}
                disabled={disabled}
                onClick={handleClick}
                link={path}
            >
                {props.children}
            </NavLink>
        );
    } else {
        buttonAnchor = (
            <a
                href={path}
                className={anchorClass}
                disabled={disabled}
                target={target ? '_blank' : null}
            >
                {props.children}
            </a>
        );
    }

    return buttonAnchor;
};

ButtonAnchor.propTypes = {
    path: propTypes.string,
    anchorClass: propTypes.string,
    disabled: propTypes.bool,
    internal: propTypes.bool,
    navLink: propTypes.bool
};

export default connect()(ButtonAnchor)


// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/Anchor.js